const PictProvider = require('pict-provider');

const DEFAULT_PROVIDER_CONFIGURATION =
{
	ProviderIdentifier: 'RecordExtension-Provider',
	EntityType: 'Sample',

	AutoInitialize: true,
	AutoInitializeOrdinal: 0,
};

class RecordExtensionProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, Object.assign({}, DEFAULT_PROVIDER_CONFIGURATION, pOptions), pServiceHash);

		/** @type {import('../LIMS-Application-Web.js').LIMSPict} */
		this.pict;
	}

	/**
	 * @param {string} uri - The URI to fetch data from.
	 */
	async _get(uri)
	{
		return new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.getJSON(uri, (err, data) =>
			{
				if (err)
				{
					this.pict.log.error('Error fetching data from URI:', uri, err);
					reject(err);
					return;
				}

				resolve(data);
			});
		});
	}

	/**
	 * @param {string} entityType - The type of entity to load the schema for.
	 */
	async loadSchema(entityType)
	{
		//FIXME: add this to the fable service below (and finish it)
		const rootManifest = await this._get(`ManifestSchemas/FilteredTo/FBL~Type~EQ~RecordExtension~FBV~SubType~EQ~${entityType}`).then((manifestSchemas) => manifestSchemas[0]);
		if (!rootManifest)
		{
			return null;
		}
		const manifestSchemaPartialJoins = await this._get(`ManifestSchemaManifestSchemaPartialJoins/FilteredTo/FBL~IDManifestSchema~EQ~${rootManifest.IDManifestSchema}`);
		const manifestPartials = manifestSchemaPartialJoins.length > 0 ?
			await this._get(`ManifestSchemaPartials/FilteredTo/FBL~IDManifestSchemaPartial~INN~${manifestSchemaPartialJoins.map((m) => m.IDManifestSchemaPartial).join()}`) : [];
		const manifest = this.pict.ManifestPackagingService._mergeManifests(rootManifest, manifestPartials);
		//TODO: atm this is used for forms only, so it creates this wrapper
		return manifest?.DefaultFormManifest;
	}

	/**
	 * @param {string} entityType - The type of entity to extend records for.
	 * @param {Array<Record<string, any>>} records - The records to extend.
	 */
	async extendRecords(entityType, records)
	{
		const extensions = await this._get(`RecordExtendedSchemaDatas/FilteredTo/FBV~EntityType~EQ~${encodeURIComponent(entityType)}~FBL~IDEntity~INN~${records.map((r) => r[`ID${entityType}`]).join()}`);
		for (const record of records)
		{
			const extension = extensions.find((e) => e.IDEntity == record[`ID${entityType}`]);
			if (extension)
			{
				//TODOL keep this whole record around?
				record.Extended = extension.Data || { };
			}
			else
			{
				record.Extended = { };
			}
		}
	}

	async saveExtendedSchemaData(entityType, entityID, extended)
	{
		let recordExtendedSchemaData = await this._get(`RecordExtendedSchemaDatas/FilteredTo/FBL~IDEntity~EQ~${entityID}~FBV~EntityType~EQ~${encodeURIComponent(entityType)}`)
			.then((data) => data[0]);
		if (!recordExtendedSchemaData)
		{
			recordExtendedSchemaData = {
				EntityType: entityType,
				IDEntity: entityID,
				Data: { },
			};
		}
		Object.assign(recordExtendedSchemaData.Data, extended);
		await new Promise((resolve, reject) => this.pict.HeadlightRestClient.putJSON(`RecordExtendedSchemaData/Upsert`, recordExtendedSchemaData, (err, data) =>
		{
			if (err)
			{
				this.pict.log.error('Error saving extended schema data:', err);
				reject(err);
			}
			else
			{
				resolve(data);
			}
		}));
	}
}

module.exports = RecordExtensionProvider;
module.exports.default_configuration = DEFAULT_PROVIDER_CONFIGURATION;
